import React, { useState } from "react";
import { Mutation } from "react-apollo";
import { ADD_NEW_REQUEST_COMMENT } from "../queries";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";
import auth from "Auth";
import TextField from "@material-ui/core/TextField";
import { Grid } from "@material-ui/core";
import moment from "moment";

const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || "";

export default function NewDealerDetails({
  row,
  comment,
  setComment,
  errors,
  setErrors,
  isSubmit,
  setIsSubmit,
}) {
  const handleChanges = (event) => {
    const inputText = event.target.value;
    if (inputText.length <= 700) {
      setComment(inputText);
      setErrors(false);
    } else {
      setErrors("Maximum 700 words allowed");
    }
  };

  return (
    <div>
      <table cellSpacing="0" className="detailTable">
        <tbody>
          <tr>
            <td>Request Date:</td>
            <td>{row?.request_date || ""}</td>
          </tr>
          <tr>
            <td className="table_data">Full Name:</td>
            <td className="table_data">{row?.legal_name}</td>
          </tr>
          <tr>
            <td className="table_data">Business Email:</td>
            <td className="table_data">{row?.business_email}</td>
          </tr>
          <tr>
            <td className="table_data">Phone:</td>
            <td className="table_data">{row?.business_phone1}</td>
          </tr>
          <tr>
            <td className="table_data">Brand</td>
            <td className="table_data">
              {row?.carolinaskiff
                ? "Carolina Skiff"
                : row?.seachaser
                ? "Sea Chaser"
                : ""}
            </td>
          </tr>
          <tr>
            <td className="table_data">Address:</td>
            <td className="table_data">
              {row?.mailing_address || ""}, {row?.mailing_address2 || ""},{" "}
              {row?.mailing_city || ""}, {row?.mailing_country || ""},{" "}
              {row?.mailing_zipcode || ""}
            </td>
          </tr>
          <tr>
            <td className="table_data">Fulfilled On:</td>
            <td className="table_data">{row?.fulfilledon || ""}</td>
          </tr>
          <tr>
            <td className="table_data">Fulfilled By:</td>
            <td className="table_data">
              FULFILLED {row?.fulfilledby?.toUpperCase() || ""}
            </td>
          </tr>

          {row?.new_dealer_requests_comments &&
            row?.new_dealer_requests_comments?.length > 0 && (
              <tr>
                <td>Comments:</td>
                <td>{""}</td>
              </tr>
            )}
          {row?.new_dealer_requests_comments &&
            row?.new_dealer_requests_comments?.length > 0 &&
            row?.new_dealer_requests_comments.map((item) => {
              return (
                <tr>
                  {item?.status ? (
                    <td>{capitalize(item?.status)} Comments:</td>
                  ) : (
                    <td>
                      <div>{item?.profile?.company || ""}</div>
                      <span>
                        {moment(item?.created_at).format("MMMM D, YYYY h:mm a")}
                      </span>
                    </td>
                  )}
                  <td>
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.comment || "" }}
                    ></div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {auth.getRole() === "admin" ? (
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            id="comments"
            name="comments"
            label="Add Comment Here"
            multiline
            rows="4"
            variant="outlined"
            onChange={(e) => handleChanges(e)}
            margin="normal"
            value={comment || ""}
            error={errors}
            helperText={errors}
            style={{
              width: "100%",
              marginTop: "0px",
            }}
          />
        </Grid>
      ) : null}
    </div>
  );
}
